// js
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// css
import '../../styles/components/common/ProgressCircle.scss';

// responsive circle styles
const progressCircleStyle = {
  borderRadius: '100%',
  width: '100%',
  overflow: 'visible',
  paddingBottom: '100%',
  height: 0,
  position: 'relative'
};

// div-based progress bar (no labels)
const ProgressCircle = ({children, percent = 0}) => {
  percent = Math.max(0, Math.min(1, percent));
  const percent_display = (percent * 100) >> 0;
  const r = 70;
  const circ = Math.PI * (r * 2);
  const circleStyle = {
    strokeDashoffset: circ * (1 - percent)
  };

  return (
    <div style={progressCircleStyle} className={classNames('progress-circle', {complete: (percent === 1.0)})}>
      <svg id='svg' viewBox='0 0 200 200' version='1.1' xmlns='http://www.w3.org/2000/svg'>
        {/* Transform origin (center) */}
        <g transform='translate(100, 100)'>
          {/*
            Progress indicator circle (primary blue stroke)
            - rotated -90deg so we start at 12 O'Clock
            - animating strokDashOffset via CSS
           */}
          <circle className='progress' r={r} fill='transparent' transform='rotate(-90)' strokeDasharray={circ} style={circleStyle} />
        </g>
      </svg>
      <div className='progress-content'>
        {children || (
          <label className='progress-label-default vert-center'>{ percent_display }%</label>
        )}
      </div>
    </div>
  );
};

ProgressCircle.propTypes = {
  percent: PropTypes.number,
  children: PropTypes.element
};

export default ProgressCircle;



// WEBPACK FOOTER //
// ./src/components/common/ProgressCircle.js